if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.setAttribute('disabled', 'disabled');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      // Fetch current cart contents

      getSection('cart-data')
          .then((data) => {
            const cart = JSON.parse(data);
            if (cart.items) {
              if (formData.get('offered')){
                let variantId = Number(formData.get('id'));
                let variantSku = String(formData.get('sku'));
                // Array to store already existing token IDs
                const existingTokenIds = [];

                // Check if any of the active items are already in the cart
                const existingItem = cart.items.find(cartItem =>
                    Number(cartItem.id) === variantId
                );

                // Check if customer_tags includes this SKU
                const customerHasTag = Array.isArray(cart.customer_tags) &&
                    cart.customer_tags.includes(variantSku);

                if (existingItem) {
                  // If an item with the same Id is already in the cart, add the token ID to the list
                  existingTokenIds.push(variantId);
                }

                if (existingTokenIds.length > 0 || customerHasTag) {
                  var messagePurchase = this.submitBtn.getAttribute('data-msg-only-purchase');
                  showToast(messagePurchase, 'error');
                  this.submitBtn.removeAttribute('aria-disabled');
                  this.submitBtn.removeAttribute('disabled');
                  setTimeout(() => {
                    this.submitBtn.classList.remove('is-loading');
                    this.submitBtn.classList.remove('is-success');
                  }, 400);
                  return;
                }

                this.addToCart(formData);
              } else {
                this.addToCart(formData);
              }
            } else {
              loading_bg.style.display = "none";
            }
          }).catch(error => {
        console.error('Error fetching cart data:', error);
        this.submitBtn.removeAttribute('aria-disabled');
        this.submitBtn.removeAttribute('disabled');
      });



    }

    async addToCart(formData) {
      const redirectToCheckout = formData.get('redirectToCheckout') === '1';
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        // If redirectToCheckout is true, clear the cart first
        if (redirectToCheckout) {
          // Inventory check before redirect to checkout (same logic as initCheckoutNormal in main.js)
          if (typeof window.inventoryCheck === 'function') {
            const skuForInv = formData.get('sku');
            const inventory = await window.inventoryCheck(skuForInv, 1);
            if (inventory && inventory.outOfStockItems && inventory.outOfStockItems.length > 0) {
              if (typeof popupOpen === 'function') popupOpen('popup-product-message');
              this.submitBtn.removeAttribute('aria-disabled');
              this.submitBtn.removeAttribute('disabled');
              this.submitBtn.classList.remove('is-loading');
              return;
            }
            if (inventory && inventory.activeSubs && inventory.activeSubs.length > 0) {
              if (typeof popupOpen === 'function') popupOpen('popup-active-subs');
              this.submitBtn.removeAttribute('aria-disabled');
              this.submitBtn.removeAttribute('disabled');
              this.submitBtn.classList.remove('is-loading');
              return;
            }
          }

          const clearCartResponse = await fetch(`${theme.routes.cart}/clear.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            }
          });
          if (!clearCartResponse.ok) throw new Error('Failed to clear cart');

          // Wait for cart to be cleared before proceeding
          const clearedCartResponse = await fetch(`${theme.routes.cart}.js`);
          if (!clearedCartResponse.ok) throw new Error('Failed to verify cart clear');
          const clearedCartData = await clearedCartResponse.json();

          // Verify cart is actually empty before proceeding
          if (clearedCartData.item_count > 0) {
            throw new Error('Cart was not cleared successfully');
          }
        }

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();

        if (data.status) this.setErrorMsgState(data.description);

        if (!response.ok) throw new Error(response.status);

        if (redirectToCheckout) {
          // Redirect to checkout
          window.location.href = `${theme.routes.cart}/checkout`;
          return;
        }

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                  data,
                  !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) cartItems.refreshCart();
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
            (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                  ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg.textContent
          }
        }));
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        this.submitBtn.removeAttribute('disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }

    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) this.errorMsg.textContent = error;
    }
  }

  customElements.define('product-form', ProductForm);
}
